import type { Path } from '@exam-management/router';
import { usePermission } from '@shared/permissions';
import { type PathParam, Navigate, generatePath } from 'react-router-dom';

export interface PermissionRouteData {
  requiredPermission: string[] | string;
  path: Path;
  params?: {
    [key in PathParam<Path>]?: string | null;
  };
}

interface PermissionRouteProps {
  routes: PermissionRouteData[];
}

export default function PermissionRoute({ routes }: PermissionRouteProps) {
  const { permissions } = usePermission();

  const matchedRoute = routes.find(({ requiredPermission }) => {
    const requiredPermissionsArray = Array.isArray(requiredPermission)
      ? requiredPermission
      : [requiredPermission];

    // NOTED: No required permission at all
    if (requiredPermissionsArray.length === 0) {
      return true;
    }

    return requiredPermissionsArray.some((permission) => permissions.includes(permission));
  });

  if (matchedRoute) {
    const destinationPath = matchedRoute.params
      ? generatePath(
          matchedRoute.path,
          matchedRoute.params as {
            [key in PathParam<Path>]: string | null;
          },
        )
      : matchedRoute.path;

    return <Navigate to={destinationPath} replace />;
  }

  return <Navigate to='/access-denied' replace />;
}
